export default "__VITE_ASSET__Bjnbu2j3__"